export enum DeviceTestStatusEnum {
    NotTested = "0",
    Pass = "1",
    Fail = "2"
}